import { DEFAULT_CURRENCY } from 'components/FeaturedSpreadsheet/constants';
import { UnitsFormatterProps } from './GridFormatter.props';
import { StyledUnitsButton } from './GridFormatter.styles';

const UnitsFormatter = ({ currency, onUnitsChanged, isLoading }: UnitsFormatterProps) => {
  const { units = '', symbol } = currency;
  const foreignCurrency = currency?.code !== DEFAULT_CURRENCY;

  return (
    <StyledUnitsButton onClick={onUnitsChanged} disabled={isLoading} $foreignCurrency={foreignCurrency}>
      {`${symbol} ${units}`}
    </StyledUnitsButton>
  );
};

export default UnitsFormatter;
